<template>
  <!-- eslint-disable max-len -->
  <el-dialog
    :title="'新增授权码'"
    :visible="visible"
    @close="onClose"
    @open="onOpen"
    width="30%"
    top="20vh"
    :close-on-click-modal="false"
  >
    <el-form :model="item" ref="itemform" label-width="120px" :rules="rules">
      <el-form-item label="授权码数量" prop="Number">
        <el-select v-model="item.Number" clearable placeholder="请选择授权码数量" style="width:100%">
          <el-option
            v-for="item in number"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="软件名称" prop="SoftwareID">
        <select2
          style="width: 100%"
          v-model="item.SoftwareID"
          url="software?Main=2"
          placeholder="请选择软件"
          no-data-text="无软件"
        ></select2>
      </el-form-item>
      <el-form-item label="业务类型" prop="BusinessTypeID">
        <select2
          style="width: 100%"
          v-model="item.BusinessTypeID"
          url="basic?type=BusinessType"
          :clearable="false"
          placeholder="请选择业务类型"
          noDataText="无类型"
        ></select2>
      </el-form-item>
      <el-form-item label="功能版本" prop="FunctionID">
        <select2
          style="width: 100%"
          v-model="item.FunctionID"
          url="functionversion"
          :clearable="false"
          placeholder="请选择版本"
          noDataText="无版本"
        ></select2>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="onClose">
        <i class="fas fa-times"></i> 取 消
      </el-button>
      <el-button type="primary" @click="onSubmit" :disabled="submitting">
        <i class="far fa-save"></i> 生 成
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    value: Object,
    visible: Boolean,
  },
  data() {
    return {
      businessType: [
        {
          value: 1,
          label: '业务类型1',
        },
        {
          value: 2,
          label: '业务类型2',
        },
        {
          value: 3,
          label: '业务类型3',
        },
      ],
      version: [
        {
          value: 1,
          label: '版本1',
        },
        {
          value: 2,
          label: '版本2',
        },
        {
          value: 3,
          label: '版本3',
        },
      ],
      number: [
        {
          value: 1,
          label: '1',
        },
        {
          value: 2,
          label: '2',
        },
        {
          value: 3,
          label: '3',
        },
        {
          value: 4,
          label: '4',
        },
        {
          value: 5,
          label: '5',
        },
      ],
      item: {
        AuthCodeNumber: '',
        BusinessType: '',
        Version: '',
        SoftwareID: '',
      },
      rules: {
        Number: [{ required: true, message: '数量不能为空', trigger: 'blur' }],
        FunctionVersion: [
          { required: true, message: '版本不能为空', trigger: 'blur' },
        ],
        BusinessType: [
          { required: true, message: '业务类型不能为空', trigger: 'blur' },
        ],
        SoftwareID: [
          { required: true, message: '软件不能为空', trigger: 'blur' },
        ],
      },
      submitting: false,
    };
  },
  computed: {
    token() {
      return this.$store.state.auth.token;
    },
  },
  created() { },
  methods: {
    onOpen() {
      this.item = _.clone(this.value);
    },
    onClose() {
      this.$emit('update:visible', false);
      this.$emit('cancel');
      this.$refs.itemform.resetFields();
    },
    onSubmit() {
      this.$refs.itemform.validate((valid) => {
        if (!valid) {
          return;
        }
        this.submitting = true;
        this.$emit('input', this.item);
        const itemData = { ...this.item };
        // 保存的操作
        this.$axios
          .request({
            url: 'ipccode',
            method: 'post',
            data: itemData,
          })
          .then(() => {
            this.$message.success('新增成功');
            this.submitting = false;
            this.$emit('form:created', true);
            this.$emit('form:saved', true);
            this.$emit('update:visible', false);
          })
          .catch(({ response }) => {
            this.$sys.alarmResponse(response);
            this.submitting = false;
            this.$emit('form:created', false);
            this.$emit('form:saved', false);
          });
      });
    },
  },
};
</script>
